import { SvgIconProps } from 'ui/icons';

/**
 * Modals
 */
export enum ModalAction {
  EDIT_SOURCE = 'editSource',
  CONNECT_SOURCE = 'connectSource',
  CREATE_SOURCE = 'createSource',
  CREATE_SYNC = 'createSync',
  DELETE_SYNC = 'deleteSync',
  RESTRICT_CREATE = 'restrictCreate',
}

export type ModalState = {
  action: ModalAction;
  payload?: {
    id?: number;
    syncUrl?: string;
    sourceId?: string;
    sourceType?: string;
  };
};

/**
 * Syncs
 */
export enum Status {
  Cancelled = 'cancelled',
  Disabled = 'disabled',
  Failed = 'failed',
  Interrupted = 'interrupted',
  Pending = 'pending',
  Processing = 'processing',
  Querying = 'querying',
  Queued = 'queued',
  Reporting = 'reporting',
  Success = 'success',
  Warning = 'warning',
}

export enum ScheduleTypes {
  Interval = 'interval',
  Cron = 'cron',
  Custom = 'custom',
  Manual = 'manual',
}

// https://hightouch.com/docs/api-reference#operation/ListSync
export enum IntervalUnit {
  Minute = 'minute',
  Hour = 'hour',
  Day = 'day',
  Week = 'week',
}

export type SyncSchedule = {
  type: ScheduleTypes;
  data: {
    unit?: IntervalUnit;
    quantity?: number;
    expression?: string;
  };
};
export interface Sync {
  createdAt: string; // timestamp
  disabled: boolean;
  id: number;
  modelId: number;
  name: string;
  schedule: SyncSchedule;
  slug: string;
  status: Status;
  updatedAt: string; // timestamp
  lastRunAt?: string; // timestamp | undefined
}

export interface Source {
  createdAt: string;
  name: string;
  sourceId: number;
  syncs: Sync[];
  type: string;
  updatedAt: string;
}

export type SourceDetail = {
  /** Brand logo */
  Icon: ({ height, width, color, isColorInherited, ...props }: SvgIconProps) => JSX.Element;
  /** Value used for radio button, should match source type */
  id: string;
  /** Flag to hide type from UI, but allows adding icon and metadata in advance */
  isHidden?: boolean;
  /** Source name */
  name: string;
};

export type Organization = {
  /** Total number of allowed syncs */
  allotment: number;
  /** Number of production syncs in usage */
  productionSyncsCount: number;
  /** Number of test syncs in usage */
  testSyncsCount: number;
  /**
   * Production sync usage provided by Hightouch, should mirror `productionSyncsCount`
   * but may be different depending on timing */
  usage: number;
};

export type Project = {
  /** project id */
  id: number;
  /** project name */
  name?: string;
  /** Number of syncs associated to this project */
  syncsCount: number;
  /** Identifies test projects? */
  isBillable: boolean;
};

export type HightouchOrg = {
  organization: Organization;
  projects: Project[];
};

/** Determine test or production product status */
export enum CurrentProjectStatus {
  /** provided in case of errors or unknown projects */
  NOT_IMPLEMENTED = 'notImplemented',
  /** production projects have sync limit restrictions */
  PRODUCTION = 'production',
  /** test projects do not have sync limits */
  TEST = 'test',
}
